import { Link } from 'react-router-dom';

const OTHER_CABINS = [
  {
    name: 'Lark Lodge',
    type: 'Character Cabin',
    location: 'Highlands, NC',
    features: ['Pet Friendly', 'Covered Porch', 'Stone Fireplace', 'Wooded Setting'],
    desc: 'A stylish and inviting retreat in Highlands with a covered porch, porch swing, and serene wooded surroundings. A short drive from Glen Falls and close to downtown.',
    image: 'https://static.readdy.ai/image/ad5520ee7149a263b01f4e3410f2d685/aaecc6fc9d1d9ac8bd4441230fe5683d.jpeg',
    airbnbUrl: 'https://www.airbnb.com/rooms/1617475116852690845',
    petFriendly: true,
  },
  {
    name: 'Stag Ridge',
    type: 'Luxury Forest Cabin',
    location: 'Highlands, NC — Wooded Ridge',
    features: ['Pet Friendly', 'Wraparound Deck', 'Stone Fireplace', 'Full Kitchen'],
    desc: 'A spacious luxury cabin on a wooded ridge in Highlands, featuring a wraparound deck and refined interiors. Well-positioned for exploring Glen Falls and the surrounding trail network.',
    image: 'https://static.readdy.ai/image/ad5520ee7149a263b01f4e3410f2d685/46fa8df15f4549c7bb8d2bc9e3c35336.jpeg',
    airbnbUrl: 'https://www.airbnb.com/rooms/1180227781183226897',
    petFriendly: true,
  },
  {
    name: 'Acorn Cabin',
    type: 'Charming Mountain Cabin',
    location: 'Highlands, NC — Close to Town',
    features: ['Close to Downtown', 'Stone Fireplace', 'Covered Deck', 'Wooded Setting'],
    desc: 'A charming mountain cabin steps from downtown Highlands, offering cozy interiors and easy access to local restaurants, shops, and nearby waterfall trails.',
    image: 'https://static.readdy.ai/image/ad5520ee7149a263b01f4e3410f2d685/c817d8b9e474cdd8fa639e63b7ab93d0.jpeg',
    airbnbUrl: 'https://www.airbnb.com/rooms/50702814',
    petFriendly: false,
  },
];

export default function OtherCabinsSection() {
  return (
    <section className="bg-[#EDE8E0] py-24 px-6 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-[#C9A96E] text-xs tracking-[0.3em] uppercase font-jost mb-4">/ More Options</p>
          <h2 className="font-cormorant text-5xl text-[#1A1A18] font-light">
            Other Cabins Near<br /><em className="italic">Glen Falls Area</em>
          </h2>
          <p className="text-[#5C5850] font-jost text-sm leading-relaxed max-w-2xl mx-auto mt-5">
            Beyond Glen Falls Luxury Cabin, several other well-rated properties in Highlands offer comfortable stays within easy reach of the falls and surrounding trails.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {OTHER_CABINS.map((cabin) => (
            <article key={cabin.name} className="bg-white rounded-2xl overflow-hidden flex flex-col">
              <div className="h-56 overflow-hidden relative">
                <img
                  src={cabin.image}
                  alt={`${cabin.name} cabin near Glen Falls in Highlands NC`}
                  className="w-full h-full object-cover object-top"
                />
                {cabin.petFriendly && (
                  <div className="absolute top-4 left-4 bg-[#2D4A3E] text-white text-xs font-jost tracking-[0.1em] uppercase px-3 py-1.5 rounded-full flex items-center gap-1.5">
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-heart-line text-xs" />
                    </div>
                    Pet Friendly
                  </div>
                )}
              </div>
              <div className="p-7 flex flex-col flex-1">
                <span className="text-[#6B8C7D] text-xs tracking-widest uppercase font-jost mb-1">{cabin.type}</span>
                <h3 className="font-cormorant text-2xl text-[#1A1A18] font-medium mb-1">{cabin.name}</h3>
                <p className="text-[#9C9890] text-xs font-jost mb-4 flex items-center gap-1.5">
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-map-pin-line text-xs" />
                  </div>
                  {cabin.location}
                </p>
                <p className="text-[#5C5850] text-sm font-jost leading-relaxed mb-5 flex-1">{cabin.desc}</p>
                <div className="flex flex-wrap gap-2 mb-6">
                  {cabin.features.map((f) => (
                    <span key={f} className="text-xs font-jost px-3 py-1 rounded-full bg-[#F5F1EB] text-[#5C5850]">{f}</span>
                  ))}
                </div>
                <a
                  href={cabin.airbnbUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whitespace-nowrap inline-flex items-center justify-center gap-2 border border-[#2D4A3E] text-[#2D4A3E] text-xs font-jost tracking-[0.12em] uppercase px-5 py-2.5 rounded-full cursor-pointer hover:bg-[#2D4A3E] hover:text-white transition-all duration-200"
                >
                  <div className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-external-link-line text-xs" />
                  </div>
                  View on Airbnb
                </a>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/best-luxury-cabins"
            className="inline-flex items-center gap-3 bg-[#2D4A3E] text-white text-xs tracking-[0.2em] uppercase font-jost px-10 py-4 rounded-full hover:bg-[#1e3329] transition-colors cursor-pointer whitespace-nowrap"
          >
            View Full Cabin Guide
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line" />
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}
